// import { UserType } from '~/utils/enum'
import articleDetail from 'pages/article/articleDetail.vue'

const Article = [
  {
    name: 'ArticleDetail',
    path: '/ArticleDetail/:id',
    component: articleDetail,
    meta: {
      title: '文章详情'
    }
  }
]
export default Article
